export default __webpack_public_path__ + "static/media/036-car wash.3c0860b6.svg";